import { LambdaClient } from '@aws-sdk/client-lambda';
import { S3Client } from '@aws-sdk/client-s3';
import { DocumentDisplayer } from './DocumentDisplayer';
import colorPhoto from '../../Mitchell2017.jpeg';

interface DocumentsSectionProps {
  lambdaClient: LambdaClient;
  s3Client: S3Client;
  isAdmin: boolean;
  isPostCollege: boolean;
  isAdvisor: boolean;
}

export const DocumentsSection = (props: DocumentsSectionProps) => {
  return (
    <div id="documentDisplayer" className="relative h-fit overflow-hidden dark:bg-slate-900 bg-slate-50">
      <div className="container mx-auto px-6 py-8 sm:py-16 max-w-5xl flex flex-col relative mb-4">
        <img
          className="w-full h-56 sm:h-64 lg:h-80 object-cover object-[center_40%] rounded-3xl shadow-md mb-6 sm:mb-12"
          src={colorPhoto}
          alt="Color Photo"
        />
        <div className="w-full flex flex-col relative">
          <DocumentDisplayer
            lambdaClient={props.lambdaClient}
            s3Client={props.s3Client}
            isAdmin={props.isAdmin}
            isPostCollege={props.isPostCollege}
            isAdvisor={props.isAdvisor}
          />
        </div>
      </div>
    </div>
  );
};
